import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppSettings } from '../enums/app-settings.enum';
import { EnvironmentConfigurations } from '../models/EnvironmentConfigurations';

@Injectable({
    providedIn: 'root'
})
export class ApplicationInitializationService {

    environmentConfig: EnvironmentConfigurations;

    constructor(private http: HttpClient) { }

    initializeApp() {
        return this.http.get(environment?.B2C_URL + '/hybridEnvironmentConfigurations.service').toPromise()
            .then(async (response: any) => {
                this.environmentConfig = response?.HYBRID_DYNAMIC_CONFIGS;
                window.name = JSON.stringify(response?.HYBRID_DYNAMIC_CONFIGS);     
                this.environmentConfig.IS_ACTIVITY_LOGGING_ENABLED = response?.IS_ACTIVITY_LOGGING_ENABLED;
                this.environmentConfig.IS_AECB_ENABLED = response?. IS_AECB_ENABLED;
                this.environmentConfig.POSTPAID_PREMIUM_PLAN_TYPE = response?.POSTPAID_PREMIUM_PLAN_TYPE;
                this.environmentConfig.B2C_PRORATA_TOTAL_VALUE = response?.B2C_PRORATA_TOTAL_VALUE;
                this.environmentConfig.CMS_URL_NEW_FRAGMENTPATH = response?.CMS_URL_NEW_FRAGMENTPATH;
                this.environmentConfig.IS_RAMZAN_DELIVERY_LABEL = response?.IS_RAMZAN_DELIVERY_LABEL ?? false;
                this.environmentConfig.IS_VISITOR_LINE_PRE_ARRIVAL_BULK_ACTIVATION = response?.IS_VISITOR_LINE_PRE_ARRIVAL_BULK_ACTIVATION ?? "false";
                this.environmentConfig.TRADE_IN_BANAER_CHECKOUT_DISABLE = response?.TRADE_IN_BANAER_CHECKOUT_DISABLE;
                this.environmentConfig.CHECK_PREMIUM_PRICE = response?.CHECK_PREMIUM_PRICE;
                this.environmentConfig.BNPL_TABBY_DISABLE = response?.BNPL_TABBY_DISABLE;
                this.environmentConfig.ENABLE_OTP_AUTHERIZATION_CHECKEOUT = response?.ENABLE_OTP_AUTHERIZATION_CHECKEOUT;
                this.environmentConfig.DISABLE_DEVICE_PURCHASE_ALTERNATE_CONTACT_NO = response?.DISABLE_DEVICE_PURCHASE_ALTERNATE_CONTACT_NO;
                this.environmentConfig.DISABLE_NEW_ESIM_FLOW = response?.DISABLE_NEW_ESIM_FLOW;
                this.environmentConfig.MAGENTO_STOREFRONT_CONFIGURATIONS = response?.MAGENTO_STOREFRONT_CONFIGURATIONS;
                this.environmentConfig.IS_FR_MOI_ENABLED = String(response?.IS_FR_MOI_ENABLED).toLocaleLowerCase() === 'true';
                this.environmentConfig.IS_FR_MOI_APP_RELEASE_ENABLED = String(response?.IS_FR_MOI_APP_RELEASE_ENABLED).toLocaleLowerCase() === 'true';
            })
            .catch((error) => {
                // When service fails, get the configurations from the backup
                this.prepareConfigurationBackup();

            });
    }

    prepareConfigurationBackup() {
        this.environmentConfig = new EnvironmentConfigurations();

        this.environmentConfig.CMS_HOST = environment?.CMS_HOST;
        this.environmentConfig.GTM = environment?.GTM;
        this.environmentConfig.MAP_KEY = environment?.MAP_KEY;
        this.environmentConfig.ADOBE_SCRIPT = AppSettings.ADOBE_BACKUP_SCRIPT;
        this.environmentConfig.IS_ACTIVITY_LOGGING_ENABLED = AppSettings.IS_ACTIVITY_LOGGING_ENABLED;
        this.environmentConfig.IS_AECB_ENABLED = AppSettings?. IS_AECB_ENABLED;
        this.environmentConfig.POSTPAID_PREMIUM_PLAN_TYPE = AppSettings.POSTPAID_PREMIUM_PLAN_TYPE;
        this.environmentConfig.CMS_URL_NEW_FRAGMENTPATH = AppSettings.CMS_URL_NEW_FRAGMENTPATH;  
        this.environmentConfig.CHECK_PREMIUM_PRICE = AppSettings?.CHECK_PREMIUM_PRICE;
        this.environmentConfig.BNPL_TABBY_DISABLE = AppSettings?.BNPL_TABBY_DISABLE;  
        this.environmentConfig.ENABLE_OTP_AUTHERIZATION_CHECKEOUT = AppSettings.ENABLE_OTP_AUTHERIZATION_CHECKEOUT;  


    }
}